// pages/products/signage/GuideSign.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';
import {
  InfoSection,
  TypeBlock
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const SeagullSign = () => {

  const typeGroups = [
    {
      items: [
        { src: '/images/products/signage/seagull-sign-size.jpg',},
      ],
    },
  ];
  
  return (
    <>
      <HeroSection
        title={`갈매기표지판`}
        subtitle={`직관적인 구조의 표지판으로 \n명확한 차로 정보를 제공합니다`}
        backgroundImage="/images/products/signage/seagull-sign3.jpg"
        breadcrumbs={[
            { label: '홈', path: '/' },
            { label: '도로 안내표지시스템', path: '/products/signage' },
            { label: '갈매기표지판' }, // 현재 페이지는 path 없음
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`명확한 방향 안내를 위한 교통안전 필수 시설물`}
        title={`갈매기표지판`}
        description={
          <>
            도로 및 교차로 등에서 차량과 보행자에게 <strong>명확한 방향 안내와 차로 정보를 제공</strong>하는 교통안전 표지판으로, {' '}
            날개 모양과 같은 독특한 구조를 통해 운전자의 시선에 즉각적으로 인지되도록 설계됨
            <br />
            <br />
            <strong>시인성, 직관적 안내, 설치 편의성, 안전성</strong>을 모두 갖춘 교통안전 필수 시설물로, 도로 이용자의 안전하고 원활한 이동을 지원함
          </>
        }
        images={[
          '/images/products/signage/seagull-sign2.jpg',
          '/images/products/signage/seagull-sign3.jpg',
          '/images/products/signage/seagull-sign4.jpg',
          '/images/products/signage/seagull-sign5.jpg',
          '/images/products/signage/seagull-sign6.jpg',
        ]}
        badgeImages={[
            "/images/logo/Nara.webp",
        ]}
      />

      <SectionDivider />

      <InfoSection title="표지판 규격">
        <TypeBlock groups={typeGroups} />
      </InfoSection>

      <ProductDetailNav
        category="signage"
        currentPath="/products/signage/seagull-sign"
        listPath="/products/signage"
        // listLabel="Back To List"  // 영어로 쓰고 싶으면 이렇게
      />


      <CTASection />
    </>
  );
};

export default SeagullSign;
